import React, { FunctionComponent, ReactNode } from 'react';
import Avatar from '@justgiving/avatar';
import { Totaliser } from '@justgiving/totaliser';
import classNames from 'classnames';
import { Trans } from 'react-i18next';

import parseCurrency from '../../utils/parseCurrency';

import styles from './BenefactorListItem.scss';

type BenefactorListItemProps = {
  title: string | ReactNode;
  image: string | null | undefined;
  currencyCode: string;
  amount: number;
  totaliserValue?: number | null;
  supporterCount: number;
  url: string | undefined;
};

const BenefactorListItem: FunctionComponent<BenefactorListItemProps> = ({
  title,
  image,
  currencyCode,
  amount,
  totaliserValue,
  supporterCount,
  url,
}) => {
  return (
    <li className={styles.root}>
      {Boolean(url) ? (
        <a
          href={url}
          className={styles.avatar}
          aria-label={typeof title === 'string' ? title : ''}
          tabIndex={0}
        >
          <Avatar avatarSize="auto" picture={image ? image : ''} />
        </a>
      ) : (
        <div className={styles.avatar}>
          <Avatar avatarSize="auto" picture={image ? image : ''} />
        </div>
      )}
      <div className={styles.content}>
        <div className="jg-flex-g1">
          {Boolean(url) ? (
            <h3 className="jg-h5">
              <a href={url} className={styles.link}>
                {title}
              </a>
            </h3>
          ) : (
            <h3 className="jg-h5">{title}</h3>
          )}

          {typeof amount === 'number' && currencyCode && (
            <p
              className={classNames('jg-text--brand', 'jg-text-color-branded')}
              data-qa="benefactor-amount"
            >
              {parseCurrency(currencyCode, amount)}
            </p>
          )}
          <Trans i18nKey="common.raisedBy" count={supporterCount}>
            raised by{' '}
            <span className="jg-text--regular">
              {{ supporterCount: supporterCount }} supporter
            </span>
          </Trans>
        </div>
        {totaliserValue !== null && (
          <Totaliser
            percent={totaliserValue}
            size="small"
            className={classNames(styles.totaliser, 'jg-pull-right')}
            data-qa="benefactor-totaliser"
          />
        )}
      </div>
    </li>
  );
};

export default BenefactorListItem;
